export default {
  country: 'Country',
  language: 'Language',
  currency: 'Currency',
}
